import { defaultProfile } from '@/shared/constants'
import {
    getApiFavorites,
    markApiFavoriteItem,
    unMarkApiFavoriteItem,
    updateApiFavoritesChannel,
} from './FavoritesService'
import Channel from '@/shared/classes/channels/channel'

export type FavoriteProductType =
    | 'vod'
    | 'cutv'
    | 'web'
    | 'channel'
    | 'external'
    | 'cat'
    | 'series'
    | 'episode'

export const getFavorites = async (profileId: string) => {
    if (profileId === defaultProfile.id) return
    return getApiFavorites(profileId)
}

export const updateFavoritesChannel = async (
    channels: Channel[],
    profileId: string
) => {
    {
        if (profileId === defaultProfile.id) return
        else return updateApiFavoritesChannel(channels, profileId)
    }
}

export const markFavoriteItem = async (
    profileId: string,
    productType: FavoriteProductType,
    productId: string
) => {
    {
        if (profileId === defaultProfile.id) return
        else return markApiFavoriteItem(profileId, productType, productId)
    }
}

export const unMarkFavoriteItem = async (
    profileId: string,
    productType: FavoriteProductType,
    productId: string
) => {
    if (profileId === defaultProfile.id) return
    else return unMarkApiFavoriteItem(profileId, productType, productId)
}
